export default function initRandom() {
  const container = document.querySelector('.wrapper-employee-cta')
  if (!container) return

  const pinkBoxes = container.querySelectorAll('.pink-box')
  if (!pinkBoxes.length) return

  const previousIndex = localStorage.getItem('previousEmployeeIndex')
  let randomIndex

  do {
    randomIndex = Math.floor(Math.random() * pinkBoxes.length)
  } while (pinkBoxes.length > 1 && randomIndex == previousIndex)

  pinkBoxes.forEach((box, index) => {
    box.style.display = 'none'
    if (box.nextElementSibling) {
      box.nextElementSibling.style.display = 'none'
    }
  })

  pinkBoxes[randomIndex].style.display = 'flex'
  if (pinkBoxes[randomIndex].nextElementSibling) {
    pinkBoxes[randomIndex].nextElementSibling.style.display = 'block'
  }

  localStorage.setItem('previousEmployeeIndex', randomIndex)
}
